@if (profileFields(); as fields) {
  <div [formGroup]="form">
    <ul class="px-2">
      @for (field of fields; track field) {
        @if (form.controls[field.key]) {
          <li class="flex gap-2 mb-2">
            <plugins-checkbox
              [inputId]="field.key"
              [formControlName]="field.key"
              icon="checkmark"
              [color]="baseColor"
              [inputStyle]="{ scale: 0.8 }"
              style="overflow: visible"
              [pluginsTooltip]="
                'userDetails.userProfileFieldPicker.requiredField' | translate
              "
              [pluginsTooltipDisabled]="!requiredFields()[field.key]"
            />
            <label [for]="field.key" class="field-label">
              <span class="field-key">{{ field.key }}</span>
              <span class="field-value">{{ field.value }}</span>
            </label>
          </li>
        }
      }
    </ul>
  </div>
} @else {
  <icon-spinner
    class="mr-2"
    animation="spin duration-400ms iterate-infinite"
    [size]="18"
  />
}
